import { ApiResponse, getRequest } from "@/data/apiClient";
import { UserDetails, UserProfile } from "@/data/repos/commonModels";

export async function getUserDetails(
  id: number,
  includeParents: boolean
): Promise<ApiResponse<UserDetails>> {
  return getRequest("user", { id, includeParents });
}
export async function getUserProfiles(
  includeParents: boolean
): Promise<ApiResponse<UserProfile[]>> {
  return await getRequest("userProfiles", { includeParents });
}
